/* eslint-disable react/require-default-props -- defaults via destructuring; no defaultProps (React 19) */
import React from 'react';
import PropTypes from 'prop-types';

const VIEWBOX_WIDTH = 40;
const VIEWBOX_HEIGHT = 51;

const COMPLIANCE_PACKAGE_DEFINITION_PATH =
  'M19.8164 0C29.9398 0 38.1465 8.20665 38.1465 18.3301C38.1465 22.8165 36.5336 26.9253 33.8574 30.1113L40 44.1689L31.2246 41.6211L27.2373 50.1641L21.3623 36.5938C20.8527 36.6363 20.337 36.6602 19.8164 36.6602C19.3996 36.6601 18.9861 36.6446 18.5762 36.6172L12.7676 50.1738L8.77539 41.6211L0 44.1689L6.0166 30.3936C3.19632 27.1699 1.48633 22.9498 1.48633 18.3301C1.48635 8.20679 9.69316 0.000223341 19.8164 0ZM32.4004 31.6572C30.5673 33.3887 28.3773 34.7452 25.9521 35.6064C25.1894 35.9245 24.3702 36.2277 23.4639 36.5283L27.3047 45.3965L30.1611 39.2764L36.5381 41.127L32.4004 31.6572ZM3.46191 41.127L9.83887 39.2764L12.6914 45.3867L16.542 36.4014C16.4657 36.376 16.3905 36.3493 16.3154 36.3242C12.9579 35.6747 9.92669 34.1109 7.49316 31.8994L3.46191 41.127ZM19.8164 2.44434C11.043 2.44456 3.93069 9.55658 3.93066 18.3301C3.93066 27.1036 11.0429 34.2156 19.8164 34.2158C28.5901 34.2158 35.7031 27.1037 35.7031 18.3301C35.7031 9.55644 28.59 2.44434 19.8164 2.44434ZM19.8164 6.11035C26.5654 6.11035 32.0371 11.5811 32.0371 18.3301C32.0371 25.079 26.5654 30.5498 19.8164 30.5498C13.0675 30.5497 7.59668 25.079 7.59668 18.3301C7.5967 11.5812 13.0675 6.11044 19.8164 6.11035ZM19.8164 8.06543C14.1474 8.06552 9.55178 12.661 9.55176 18.3301C9.55176 23.9992 14.1474 28.5946 19.8164 28.5947C25.4855 28.5947 30.0811 23.9992 30.0811 18.3301C30.081 12.661 25.4855 8.06543 19.8164 8.06543ZM24.9912 13.7285C25.3729 13.3469 25.9913 13.3469 26.373 13.7285C26.7548 14.1103 26.7548 14.7295 26.373 15.1113L18.3086 23.1758C17.9268 23.5576 17.3076 23.5576 16.9258 23.1758L13.2598 19.5098C12.8782 19.128 12.8781 18.5097 13.2598 18.1279C13.6415 17.7462 14.2608 17.7462 14.6426 18.1279L17.6172 21.1025L24.9912 13.7285Z';

/** Menu `<i>` class — uses mask + currentColor to match other sidebar icons. */
export const COMPLIANCE_PACKAGE_DEFINITION_MENU_ICON_CLASS = 'ds-menu-icon--compliance-package-definition';

/** Default fill — inherits sidebar/menu gray via currentColor. */
export const COMPLIANCE_PACKAGE_DEFINITION_ICON_DEFAULT_FILL = 'currentColor';

const iconPropTypes = {
  size: PropTypes.number,
  fill: PropTypes.string,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/**
 * Compliance package definition badge with checkmark (40×51). Color via `fill` or CSS `color` + `currentColor`.
 * Pass `aria-label` when the icon conveys meaning without adjacent text.
 */
const CompliancePackageDefinitionIcon = ({
  size = 20,
  fill = COMPLIANCE_PACKAGE_DEFINITION_ICON_DEFAULT_FILL,
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => {
  const width = size;
  const height = (size * VIEWBOX_HEIGHT) / VIEWBOX_WIDTH;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${VIEWBOX_WIDTH} ${VIEWBOX_HEIGHT}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={['ds-icon', 'ds-icon--filled', className].filter(Boolean).join(' ')}
      aria-hidden={ariaLabel ? undefined : ariaHidden}
      aria-label={ariaLabel || undefined}
      role={ariaLabel ? 'img' : undefined}
      focusable="false"
      {...props}
    >
      <path d={COMPLIANCE_PACKAGE_DEFINITION_PATH} fill={fill} />
    </svg>
  );
};

CompliancePackageDefinitionIcon.propTypes = iconPropTypes;

export { CompliancePackageDefinitionIcon };
export default CompliancePackageDefinitionIcon;
